import { ref, onBeforeMount } from 'vue'
import NykForm from "../CustomForm/NykForm/NykForm.vue"

export default {
  name: "ContactAdvisorBlock",
  components: {
    NykForm
  },
  props: {
    formId: {
      type: String,
      required: true
    },
    formGuid: {
      type: String,
      required: true
    },
    formTitle: {
      type: String,
      required: false
    },
    apiPath: {
      type: String,
      required: true
    },
    antiForgeryToken: {
      type: String,
      required: true
    },
    allowInternationalNumber: {
      type: Boolean,
      required: false
    },
    labels: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const formElements = ref([]);
    const queryParams = ref({});
    const queryParamFields = ref([]);

    onBeforeMount(() => {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      const advisorId = urlParams.get("advisorId") || urlParams.get("advisorid")
      const centerId = urlParams.get("centerId") || urlParams.get("centerid")

      queryParams.value = {
        ...advisorId ? { advisorId: advisorId } : {},
        ...centerId ? { centerId } : {}
      };
    })

    formElements.value = [
      {
        key: 'name',
        contentType: "CustomTextboxElementBlock",
        displayName: "name",
        properties: {
          validators: [
            {
              type: "RequiredValidator",
              model: {
                message: props.labels.requiredValidationFailureMessage
              }
            }
          ],
          label: props.labels.nameLabel,
          maxLength: 500,
          clearButtonAriaLabel: props.labels.clearButtonAriaLabel
        },
      },
      {
        key: 'address',
        contentType: "CustomAddressElementBlock",
        displayName: "address",
        properties: {
          validators: [
            {
              type: "RequiredValidator",
              model: {
                message: props.labels.requiredValidationFailureMessage
              }
            }
          ],
          autoCompleteAddress: true,
          label: props.labels.addressLabel,
          maxLength: 1000,
          clearButtonAriaLabel: props.labels.clearButtonAriaLabel
        },
      },
      {
        key: 'phone',
        contentType: "CustomPhoneElementBlock",
        displayName: "phone",
        properties: {
          validators: [
            {
              type: "RequiredValidator",
              model: {
                message: props.labels.requiredValidationFailureMessage
              }
            }
          ],
          label: props.labels.phoneLabel,
          countryCodeLabel: props.labels.countryCodeLabel,
          countryCodeFormatValidationFailureMessage: props.labels.countryCodeFormatValidationFailureMessage,
          allowInternationalNumber: props.allowInternationalNumber,
          maxLength: 20,
          clearButtonAriaLabel: props.labels.clearButtonAriaLabel
        },
      },
      {
        key: 'senderEmail',
        contentType: "CustomEmailElementBlock",
        displayName: "senderEmail",
        properties: {
          validators: [
            {
              type: "RequiredValidator",
              model: {
                message: props.labels.requiredValidationFailureMessage
              }
            },
            {
              type: "EmailFormatValidator",
              model: {
                message: props.labels.emailFormationValidationFailureMessage
              }
            }
          ],
          label: props.labels.emailLabel,
          maxLength: 500,
          clearButtonAriaLabel: props.labels.clearButtonAriaLabel
        },
      },
      {
        key: 'comment',
        contentType: "CustomTextareaElementBlock",
        displayName: "comment",
        properties: {
          validators: [
            {
              type: "RequiredValidator",
              model: {
                message: props.labels.requiredValidationFailureMessage
              }
            }
          ],
          label: props.labels.commentLabel,
          maxLength: 1000,
          clearButtonAriaLabel: props.labels.clearButtonAriaLabel
        },
      },
      {
        key: "consent",
        contentType: "NykCheckbox",
        displayName: "consent",
        properties: {
          label: props.labels.legalRichText,
          description: props.labels.legalDescription,
          validators: [
            {
              type: "RequiredValidator",
              model: {
                message: props.labels.requiredValidationFailureMessage
              }
            }
          ]
        },
      },
      {
        key: "submit-button",
        contentType: "CustomSubmitButtonElementBlock",
        displayName: "submit-button",
        properties: {
          label: props.labels.submitButtonLabel,
        }
      }
    ];

    return {
      formElements,
      queryParams,
      queryParamFields
    }
  }
}
